import React, { useState, useEffect, useReducer } from 'react';

import Form from '../../np-form/Form';
import { withStyles } from '@material-ui/core';
import * as formUtility from '../../np-form/utility';
import { snackActions } from '../../sc-utilities/SnackBar';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

const updateFormState = props => {
    const { changePaletteState, handleUpload, fileName, translations } = props;

    const form = {
        OrderID: {
            elementType: 'select_v2',
            elementConfig: {
                type: 'select',
                label: translations['order'] || 'Order',
                className: null,
                margin: "dense",
                fullWidth: true,
                options: changePaletteState.orders ? changePaletteState.orders : []
            },
            formHelperText: translations['order_text'] || "Please select order",
            value: null,
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        TransportColliID: {
            elementType: 'select_v2',
            elementConfig: {
                type: 'select',
                label: translations['transport_colli'] || 'Transport colli order',
                className: null,
                margin: "dense",
                fullWidth: true,
                options: []
            },
            formHelperText: translations['transport_colli_text'] || "Please select transport colli",
            value: null,
            validation: {
                required: false
            },
            valid: true,
            touched: true
        },
        ColliID: {
            elementType: 'select_v2',
            elementConfig: {
                type: 'select',
                label: translations['colli'] || 'Colli',
                className: null,
                margin: "dense",
                fullWidth: true,
                options: changePaletteState.Collies ? changePaletteState.Collies : []
            },
            formHelperText: translations['colli_text'] || "Please select colli palette",
            value: null,
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        File: {
            elementType: 'file',
            elementConfig: {
                ID: "OldSecurazeDataID",
                accept: ['application/json'],
                style: {},
                translations: translations,
                type: 'file',
                handleUpload: handleUpload,
                fileName: fileName,
                dragDrop: true,
                text: `${translations['drag_and_drop_an'] || 'Drag and drop an'} .json ${translations['file_here'] || 'file here or click'}`,
            },
            validation: {
                required: false
            },
            valid: true,
            touched: true
        }
    };

    return form;
}

const ImportDataFromOldSecuraze = props => {
    const { classes, changePaletteState, activeCustomer, translations } = props;

    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            file = {};
        }
        setFileToSend({ fileToSend: file, fileName: file.name });

    }

    const [importForm, dispatch] = useReducer(oldSecurazeDataReducer, updateFormState({
        ...props,
        fileName: fileToSend.fileName,
        handleUpload: handleUpload
    }));

    const [formIsValid, setFormIsValid] = useState(false);

    useEffect(() => {
        dispatch({ type: "form", form: updateFormState({ ...props, handleUpload: handleUpload }) });
    }, [props]);

    useEffect(() => {
        if (fileToSend.fileName) {
            dispatch({ type: "filename", fileName: fileToSend.fileName });
        }
    }, [fileToSend.fileName]);

    const inputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, importForm);
        if (inputIdentifier === 'OrderID') {
            for (var order of changePaletteState.orders) {
                if (order.value === event.target.value) {
                    dispatch({
                        type: "form",
                        form: {
                            ...updateState.myForm,
                            TransportColliID: {
                                ...updateState.myForm.TransportColliID,
                                elementConfig: {
                                    ...updateState.myForm.TransportColliID,
                                    options: order.TransportCollies
                                },
                                value: null
                            }
                        }
                    });
                    setFormIsValid(updateState.formIsValid);
                    return;
                }
            }
        }
        dispatch({ type: "form", form: updateState.myForm });
        setFormIsValid(updateState.formIsValid);
    }

    const submitHandler = async event => {
        event.preventDefault();
        const formData = formUtility.getFormData(importForm);
        if (!fileToSend.fileName) {
            return snackActions.snackBarComponent('Please choose JSON file.', 'warning')
        }

        dispatch({ type: "form", form: {} });
        setFormIsValid(false);
        const data = new FormData();
        data.append('File', fileToSend.fileToSend);
        data.append('FileName', fileToSend.fileName);
        data.append('TransportColliID', formData.TransportColliID);
        data.append('OrderID', formData.OrderID);
        data.append('ColliID', formData.ColliID);
        data.append('ActiveCustomerID', activeCustomer);

        let token = localStorage.getItem('SESSION');

        data.append('Token', token);

        await props.importData(data);
        setFileToSend({ fileToSend: {}, fileName: '' });
        dispatch({ type: "form", form: updateFormState({ ...props, handleUpload: handleUpload }) })

    }

    return (
        <Form
            formIsValid={formIsValid}
            classes={classes}
            form={importForm}
            formTitle={` ${translations['import_data_old'] || "Import data from old"}  securaze`}
            buttonText={translations['import'] || "Import"}
            submitHandler={submitHandler}
            inputChangedHandler={inputChangedHandler}
            submitButtonColor={'primary'}
        />
    )
}

const oldSecurazeDataReducer = (state, action) => {
    switch (action.type) {
        case 'filename':
            return {
                ...state,
                File: { ...state.File, elementConfig: { ...state.File.elementConfig, fileName: action.fileName } }
            };
        case 'form':
            return action.form;
        default:
            throw new Error({ message: 'Something went wrong. Please contact administrator.' });
    }
}

export default withStyles(styles, { withTheme: true })(ImportDataFromOldSecuraze);